import React, { useEffect, createElement } from 'react';
import { LandingPage } from './pages/LandingPage';
const LCP_IMAGE = 'https://cdn.magicpatterns.com/uploads/atmHyCXCYdpVMzEuqECSXU/1500-CLIENTE-SODDISFATTI-_3_.webp';
const GOOGLE_FONTS_URL = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=optional';
(function injectResourceHints() {
  if (typeof document === 'undefined') return;
  const w = window as any;
  if (w.__mpHintsInjected) return;
  w.__mpHintsInjected = true;
  const head = document.head;
  const addLink = (attrs: Record<string, string>) => {
    const link = document.createElement('link');
    Object.entries(attrs).forEach(([k, v]) => link.setAttribute(k, v));
    head.appendChild(link);
  };
  // Preconnect to critical origins (font CDN + image CDN)
  addLink({
    rel: 'preconnect',
    href: 'https://fonts.gstatic.com',
    crossorigin: 'anonymous'
  });
  addLink({
    rel: 'preconnect',
    href: 'https://cdn.magicpatterns.com',
    crossorigin: 'anonymous'
  });
  // Preload the LCP hero image with high fetch priority
  const preload = document.createElement('link');
  preload.rel = 'preload';
  preload.as = 'image';
  preload.href = LCP_IMAGE;
  (preload as any).fetchPriority = 'high';
  head.appendChild(preload);
  // dns-prefetch for tracking domains (loaded later, non-blocking)
  addLink({
    rel: 'dns-prefetch',
    href: 'https://connect.facebook.net'
  });
  addLink({
    rel: 'dns-prefetch',
    href: 'https://www.facebook.com'
  });
  // Google Fonts: load non-blocking via media swap
  const fontLink = document.createElement('link');
  fontLink.rel = 'stylesheet';
  fontLink.href = GOOGLE_FONTS_URL;
  fontLink.media = 'print';
  fontLink.onload = function () {
    fontLink.media = 'all';
  };
  head.appendChild(fontLink);
})();
function loadMetaPixel() {
  const w = window as any;
  if (w.fbq) return;
  const n: any = w.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!w._fbq) w._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);
  w.fbq('init', '1170774765082882');
  w.fbq('track', 'PageView');
  const img = document.createElement('img');
  img.height = 1;
  img.width = 1;
  img.style.display = 'none';
  img.src = 'https://www.facebook.com/tr?id=1170774765082882&ev=PageView&noscript=1';
  document.body.appendChild(img);
}
export function App() {
  useEffect(() => {
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(loadMetaPixel, {
        timeout: 3500
      });
    } else {
      setTimeout(loadMetaPixel, 2000);
    }
  }, []);
  return <LandingPage data-id="element-0" />;
}